<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Toppings</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Toppings
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <div class="content-header-right col-md-6 col-12 mb-md-0 mb-2">
                <button @click.prevent="addToppingModal" data-toggle="modal" data-target="#faq-modal"
                        type="button"
                        class="btn btn-outline-primary float-md-right"><i class="feather icon-plus icon-left"></i>
                    Add Toppings
                </button>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Toppings</h4>
                </div>

                <div class="card-body">
                    <list-controls
                        :search.sync="search"
                        search-id="topping-search"
                        placeholder="Search by topping name"
                        show-filters
                        @apply="applyFilters"
                        @reset="resetFilters"
                    >
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="topping-always-paid">By Always Paid</label>
                                <select id="topping-always-paid" class="form-control form-control-sm" v-model="filters.always_paid">
                                    <option :value="null">All</option>
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                            </div>
                        </div>
                    </list-controls>
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        :sort-options="sortingOptions"
                        @on-page-change="this.onPageChange"
                        @on-per-page-change="this.onPerPageChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allToppings"
                        ref="myTable"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.field === 'image'">
                               <a :href="props.row.image" target="_blank">
                                   <img :src="props.row.image" :alt="props.row.name +' Image'"
                                        class="img-thumbnail img-fluid"
                                        style="height: auto; max-width:130px; vertical-align: middle; width: 100%;">
                               </a>
                            </span>
                            <table-row-actions v-else-if="props.column.field === 'action'">
                                <a href="#"
                                   class="dropdown-item"
                                   @click.prevent="editToppingModal(props.row.topping_name, props.row.price, props.row.id, props.row.image, props.row.always_paid )">
                                    <i class="feather icon-edit"></i>
                                    Edit
                                </a>
                                <a href="#" @click.prevent="showAlert(props.row.id)" class="dropdown-item text-danger">
                                    <i class="feather icon-trash-2"></i>
                                    Delete
                                </a>
                            </table-row-actions>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>

        <div class="modal fade add-topping-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" data-backdrop="static"
             aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <form @submit.prevent="addTopping">
                        <div class="modal-header"><h4 id="myModalLabel1" class="modal-title">
                            {{ this.isEditing ? "Edit" : "Add" }} Toppings</h4>
                            <button type="button" data-dismiss="modal" aria-label="Close" class="close"><span
                                aria-hidden="true">×</span></button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group"><label>Topping Name</label>
                                <input type="text" required="required" v-model="topping.topping_name"
                                       class="form-control">
                                <div v-if="topping.errors.topping_name" class="text-danger text-small">
                                    {{ topping.errors.topping_name }}
                                </div>
                            </div>

                            <div class="form-group"><label>Topping Price</label>
                                <input type="text" required="required" v-model="topping.price"
                                       class="form-control">
                                <div v-if="topping.errors.price" class="text-danger text-small">
                                    {{ topping.errors.price }}
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="controls">
                                    <label>Topping Image</label>
                                    <template v-if="this.topping.image.hasOwnProperty('image')">
                                        <div class="row">
                                            <div class="col-3">
                                                <a :href="topping.image.image" target="_blank">
                                                    <img :src="topping.image.image_thumbnail"
                                                         :alt="topping.name +' Image'"
                                                         class="img-thumbnail img-fluid"
                                                         style="height: auto; max-width:130px; vertical-align: middle; width: 100%;">
                                                </a>
                                            </div>
                                        </div>
                                    </template>
                                    <button type="button" data-toggle="modal" data-target="#gallery-modal"
                                            class="form-control"> {{ topping.image.image ? 'Change' : 'Choose' }}
                                        Topping Image
                                    </button>
                                    <div v-if="topping.errors.image" class="text-danger text-small">
                                        {{ topping.errors.image }}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="controls">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" v-model="topping.always_paid"
                                               id="defaultCheck1"
                                               :true-value="true" :false-value="false">
                                        <label class="form-check-label" for="defaultCheck1">
                                            Is this topping always paid?
                                        </label>
                                    </div>
                                    <span v-if="topping.errors.always_paid"
                                          class="text-danger text-small">{{ topping.errors.always_paid }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button class="btn btn-primary" :disabled="saving">
                                Save <i class="fa fa-spinner fa-spin" v-if="saving"/>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <gallery-modal @chooseImage="chosenImage" gallery-header="Add Images to Product Gallery"></gallery-modal>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2';
import ListControls from '@/Shared/ListControls';
import DeleteAlert from "../../../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../../../Shared/Mixins/PaginationMixin";
import ListQueryMixin from "../../../../Shared/Mixins/ListQueryMixin";
import GalleryModal from "@/Shared/GalleryModal";


export default {
    metaInfo: {title: 'Toppings'},
    props: [
        'toppings',
    ],
    layout: Layout,
    components: {
        Link,
        ListControls,
        GalleryModal
    },
    mixins: [
        DeleteAlert,
        PaginationMixin,
        ListQueryMixin,
    ],
    data() {
        return {
            topping: this.$inertia.form({
                topping_name: null,
                price: null,
                id: null,
                image: {},
                always_paid: false,
            }),
            filters: {
                always_paid: null,
            },
            isLoadingFilter: false,
            allToppings: [],
            totalRecords: 0,
            serverParams: {
                page: 1,
                perPage: 10
            },

            paginationOptions: {
                enabled: true,
                mode: 'pages',
                perPage: 10,
                perPageDropdown: [5, 10, 20, 50, 100, 200],
                dropdownAllowAll: false,
            },

            sortingOptions: {
                enabled: false,
            },

            columns: [
                {label: 'S/N', field: 'sn', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Topping Name', field: 'topping_name', thClass: 'text-center', tdClass: 'text-center'},
                {
                    label: 'Topping Price',
                    field: 'price',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                    formatFn: this.formatFn,
                },
                {label: 'Image', field: 'image', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Action', field: 'action', sortable: false, thClass: 'text-center', tdClass: 'text-center'},
            ],
            tableDataLoading: false,
            saving: false,
            isEditing: false,
        }
    },

    mounted() {
        this.allToppings = this.toppings.data;
        this.totalRecords = this.toppings.total
    },

    methods: {
        chosenImage(image) {
            if (this.topping.hasOwnProperty('image')) {
                this.topping.image = image;
            }
        },
        formatFn: function (value) {
            return '₦' + value;
        },
        addToppingModal() {
            $('.add-topping-modal').modal('show');
            this.topping.topping_name = ""
            this.topping.price = "";
            this.isEditing = false;
            this.topping.image = {};
            this.topping.always_paid = false;
        },

        async editToppingModal(name, price,resourceId, image, always_paid) {
            this.topping.topping_name = name;
            this.topping.price = price;
            this.isEditing = true;
            this.topping.id = resourceId
            this.topping.image = {
                image,
                image_thumbnail: image
            };
            this.topping.always_paid = always_paid;

            $('.add-topping-modal').modal('show');
        },

        async addTopping(id = null) {
            this.saving = true;
            const options = {
                preserveScroll: true,
                onSuccess: () => {
                    this.saving = false
                    $('.add-topping-modal').modal('hide');

                },
                onError: () => {
                    this.saving = false;
                }
            };

            this.topping.image = this.topping.image.image ?? null;

            this.isEditing ?
                this.topping.put(route('admin.categories.toppings.update', this.topping.id), options)
                :
                this.topping.post(route('admin.categories.toppings.store'), options);

            await this.paginatedData();
        },

        paginatedData() {
            return this.loadList('admin.categories.toppings.index', 'allToppings');
        },
        async deleteTopping(id) {
            await this.$inertia.delete(route('admin.categories.toppings.delete', id), {
                preserveScroll: true,
                onSuccess: async() => {
                    await this.paginatedData();
                }
            })
        },
        async showAlert(toppingId) {
            const details = {
                title: "Are you sure you want to delete this topping?",
                text: "You won't be able to revert this!",
            }
            await this.deleteAlert(details.title, details.text) ? await this.deleteTopping(toppingId) : "";
        },
    }
}
</script>
